import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withOffshoreOperationalEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
